import {PaymentType} from "../../../App";
import {useState} from "react";
import {
    Button,
    Descriptions,
    Form,
    Input,
    Layout,
    message,
    Radio,
    Typography
} from "antd";
import {useOrderId} from "../../../hooks/UseOrderId";
import WrappedCard from "../../antd/WrappedCard";
import {Copyable} from "../../common/Copyable";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import {usePostCheckoutApi, usePostCheckoutTypeApi} from "../../../api";

const {Content} = Layout;

const stepMapping: any = {
    1: {
        title: "Please input your payment information"
    },
    2: {
        title: "Please input your OTP number"
    }
};

function PkSimpaisaMode({getCheckoutInfoData}: PaymentType) {
    const id = useOrderId();

    // NOTICE: ant design
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [submitCheckout, setSubmitCheckout] = useState(false);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    // Step 1: 送 payment API
    const {executePost: executePostPayment} = usePostCheckoutTypeApi(id);

    // Step 2: 送 otp API
    const {executePost: executePostOTP} = usePostCheckoutApi(id);

    const onFormFinish = (values: any) => {
        let data = {};
        setLoading(true);

        switch (step) {
            case 1:
                data = {
                    providerType: ProviderTypeEnum.WALLET,
                    providerName: values.providerName,
                    customerAccount: values.phoneNumber
                };

                executePostPayment({
                    data
                })
                    .then(() => {
                        setFormData(data);
                        setStep(2);
                    })
                    .catch((error) => {
                        messageApi.error("Failed:" + error?.response?.data?.title);
                    });

                setLoading(false);
                break;

            case 2:
                data = {
                    ...formData,
                    otp: values.otp
                };

                executePostOTP({
                    data
                })
                    .then(() => {
                        setSubmitCheckout(true);
                        setFormData({});
                    })
                    .catch((error) => {
                        messageApi.error("Failed:" + error?.response?.data?.title);
                    });
                setLoading(false);

                break;

            default:
                break;
        }
    };

    return (
        <>
            {contextHolder}
            {getCheckoutInfoData?.checkoutStatus !== "SUBMITTED" &&
                !submitCheckout && (
                    <Content>
                        <WrappedCard cardTitle="Information">
                            <Descriptions title="Amount" bordered>
                                <Descriptions.Item label="Amount Payable">
                                    <Typography.Title
                                        copyable={{icon: <Copyable/>}}
                                        level={5}
                                        style={{margin: 0}}
                                    >
                                        {getCheckoutInfoData?.orderAmount}
                                    </Typography.Title>
                                </Descriptions.Item>
                            </Descriptions>
                        </WrappedCard>

                        <WrappedCard cardTitle={stepMapping[step].title}>
                            <Form form={form} onFinish={onFormFinish}>
                                {step === 1 && (
                                    <>
                                        <Form.Item label="Select Payment Type" name="providerName">
                                            <Radio.Group value={CardTypeEnum}>
                                                <Radio.Button value={CardTypeEnum.EasyPaisa}>
                                                    EasyPaisa
                                                </Radio.Button>
                                                <Radio.Button value={CardTypeEnum.JazzCash}>
                                                    JazzCash
                                                </Radio.Button>
                                                {/* <Radio.Button value={CardTypeEnum.OneLink}>
                          1Link
                        </Radio.Button> */}
                                            </Radio.Group>
                                        </Form.Item>

                                        <Form.Item
                                            name="phoneNumber"
                                            label="Phone Number"
                                            rules={[{required: true}]}
                                        >
                                            <Input style={{width: "200px"}}/>
                                        </Form.Item>
                                    </>
                                )}

                                {step === 2 && (
                                    <Form.Item name="otp" rules={[{required: true}]}>
                                        <Input style={{width: "200px"}}/>
                                    </Form.Item>
                                )}

                                <Form.Item>
                                    <Button htmlType="submit" type="primary" loading={loading}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Form>
                        </WrappedCard>
                    </Content>
                )}
        </>
    );
}

export default PkSimpaisaMode;
